import s from './LeaderboardBadge.module.sass';

import { FC } from 'react';
import { WonLeaderboard } from '$store/models';
import { IcContest28 } from '$assets';
import { format } from '$utils';
import { goTo } from '$navigation/helper';
import { LEADERBOARD } from '$shared/constants/pages';

export const LeaderboardBadge: FC<{ item: WonLeaderboard }> = ({ item }) => {
  return (
    <div
      className={s.wrap}
      onClick={() =>
        goTo(LEADERBOARD, {
          id: item.id,
        })
      }
    >
      <div className={s.icon}>
        <IcContest28 />
      </div>
      <div className={s.label}>
        Top {item.rank}{' '}
        <span>
          {`'`}
          {format(item.date * 1000, 'MMM yyyy')}
        </span>
      </div>
    </div>
  );
};
